/*************************************************/
/* VUE                                           */
/*************************************************/

import { createApp, h } from 'vue';
import { createRouter, createWebHistory } from "vue-router";
import Table from './vue/table.vue';


const tableAppSelector = "#tableApp";
if (document.querySelector(tableAppSelector) != null) {
    // const tableNodeId = document.querySelector(tableAppSelector).dataset.tableNodeId;
    // const pageSize = document.querySelector(tableAppSelector).dataset.pagesize;

    const router = createRouter({
        history: createWebHistory(),
        routes: [{ path: window.location.pathname, component: Table }]
    });

    const seedData = {  };

    const tableApp = createApp({
        data() { return seedData },
        render: () => h(Table)
    }, seedData);

    tableApp.use(router);
    router.isReady().then(() => tableApp.mount(tableAppSelector));
}